<script>
  import jump from 'jump.js';
  import Title from "./components/Title.svelte";
  import Form from "./components/Form.svelte";
  import Thanks from "./components/Thanks.svelte";
  import LangSwitch from "./components/LangSwitch.svelte";

  let activeStep = $state(0);
  let language = $state(document.documentElement.lang);
  let contentWrapper = null;

  const goToNextStep = () => {
    contentWrapper.scrollTo(0, 0);
    activeStep += 1;
  };

  const close = (done = false) => {
    document.body.dataset.triggered = done ? 'done' : 'false';

    setTimeout(() => {
      contentWrapper.scrollTo(0, 0);
      activeStep = 0;
    }, 500);
  };

  $effect(() => {
    if (activeStep === 2) {
      jump(document.body);
      document.body.dataset.triggered = 'fly';

      setTimeout(() => {
        activeStep = 3;

        document.body.dataset.triggered = 'thanks';
      }, 4000);
    }
  });

  const triggers = document.querySelectorAll('.js-trigger');
  triggers.forEach((el) => {
    el.addEventListener('click', () => {
      console.log('triggered');
      document.body.dataset.triggered = 'true';
      activeStep = 1;
    });
  });
</script>

<LangSwitch language={language} />

<div class="content" bind:this={contentWrapper}>
  <div class="content-inner">
    <Title />

    {#if activeStep === 1}
      <Form {goToNextStep} {close} />
    {:else if activeStep === 3}
      <Thanks {close} />
    {/if}
  </div>
</div>

<style>
  .content {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4vw;
    width: 100%;
    height: 100%;
    z-index: 15;
    overflow: auto;
    visibility: hidden;
    backdrop-filter: blur(10px) opacity(0);
    transition: backdrop-filter 0.5s ease-in-out, background-color 0.5s ease-in-out, visibility 0.5s ease-in-out;
  }

  .content-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;
    opacity: 0;
    transition: opacity 0.5s ease-in-out;
    margin-bottom: 15vh;
    font-size: 16px;
    box-sizing: border-box;

    @media (orientation: portrait) {
      width: 100%;
      padding: 0 6vw;
    }

    @media screen and (orientation: portrait) and (min-width: 480px) {
      font-size: 18px;
    }

    @media screen and (orientation: portrait) and (min-width: 640px) {
      font-size: 20px;
    }

    @media screen and (orientation: portrait) and (min-width: 960px) {
      font-size: 24px;
    }

    @media screen and (orientation: landscape) {
      font-size: 1.4vw;
      gap: 2vw;
    }
  }

  :global(body[data-triggered="true"] .content-inner),
  :global(body[data-triggered="thanks"] .content-inner) {
    opacity: 1;
  }

  :global(body[data-triggered="true"] .content),
  :global(body[data-triggered="thanks"] .content) {
    backdrop-filter: blur(10px) opacity(1);
    background-color: var(--color-black-40);
    visibility: visible;
  }
</style>
